import React, { Fragment, useEffect, useState } from 'react'
import { Stylesubtitle, StyleTitle } from '../platform-settings/style'
import { Form, Formik } from 'formik'
import styled from '@emotion/styled'
import Fields from '@components/fields'
import Button from '@components/button'
import generalSettings from '@apis/generalSettings'
import { toast } from 'react-toastify'

const AppSettings = () => {
  const [existing, setExisting] = useState<any | null>(null)

  // Fetch existing app version settings
  const fetchAppSettings = async () => {
    try {
      const data = await generalSettings.getByKey({
        id: 'app-version',
        state: 'appSettings',
      })
      if (data) setExisting(data)
    } catch (err) {
      console.error('Failed to fetch app version settings', err)
    }
  }

  useEffect(() => {
    fetchAppSettings()
  }, [])

  const handleSubmit = async (values: {
    androidVersion: string
    iosVersion: string
    androidUrl: string
    iosUrl: string
  }) => {
    const payload: any = {
      key: 'app-version',
      value: JSON.stringify(values),
    }
    if (!existing.id) {
      payload.group = 'app-settings'
    }
    try {
      if (existing?.id) {
        await generalSettings.update({
          id: existing.id,
          state: 'appSettings',
          data: payload,
        })
        toast.success('App settings updated')
      } else {
        await generalSettings.create({
          state: 'appSettings',
          data: JSON.stringify(payload),
        })
      }
    } catch (err) {
      console.error('Failed to save app settings', err)
    }
  }

  return (
    <Fragment>
      <StyleTitle>App Version Control</StyleTitle>
      <Stylesubtitle>
        Admin can manage app version and app download URL
      </Stylesubtitle>
      <br />

      <Formik
        enableReinitialize
        initialValues={{
          androidVersion: existing?.value
            ? JSON.parse(existing.value).androidVersion
            : '',
          iosVersion: existing?.value
            ? JSON.parse(existing.value).iosVersion
            : '',
          androidUrl: existing?.value
            ? JSON.parse(existing.value).androidUrl
            : '',
          iosUrl: existing?.value ? JSON.parse(existing.value).iosUrl : '',
        }}
        onSubmit={handleSubmit}
      >
        <Form>
          <StyleFormGrid>
            <StyleTitle>For Android</StyleTitle>
            <StyleTitle>For IOS</StyleTitle>

            <Fields.Input
              name="androidVersion"
              label="Minimum App Version for Force Update"
              placeholder="Enter Version"
              styleInput="width:100%"
            />
            <Fields.Input
              name="iosVersion"
              label="Minimum App Version for Force Update"
              placeholder="Enter Version"
              styleInput="width:100%"
            />

            <Fields.Input
              name="androidUrl"
              label="Download URL for App"
              placeholder="Enter App Url"
              styleInput="width:100%"
            />
            <Fields.Input
              name="iosUrl"
              label="Download URL for App"
              placeholder="Enter App Url"
              styleInput="width:100%"
            />
          </StyleFormGrid>
          <br />
          <Button
            type="submit"
            title="Save Settings"
            justify="end"
            styleButton="width:100%; max-width:200px;"
          />
        </Form>
      </Formik>
    </Fragment>
  )
}

export default AppSettings

const StyleFormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`
